import * as THREE from 'three';
import Assets from "../assets";

function snapToPiEighths(radians) {
  const step = (Math.PI * 2) / 8;
  return Math.round(radians / step) * step;
}

export default class Ring {
    state = "left"
    planeWidth = 3.425;
    planeHeight = 2.5
    radius = 4.5
    wrap360 = gsap.utils.wrap(0, Math.PI * 2);


    constructor({ scene, camera }) {
        this.scene = scene;
        this.camera = camera;
        this.container = new THREE.Group()
        this.rotor = new THREE.Group()
        this.container.add(this.rotor)
        this.scene.add(this.container)
        this.entered = 0
        this.velocity = 0;
        this.targetVelocity = 0.0025;
        this.friction = 0.95;
        this.baseSpeed = 0.001;
        // document.body.addEventListener("mousemove", this.onMouseMove.bind(this))
    }

    initialize() {
        const { planeWidth, planeHeight, radius } = this

        const vertexShader = `
            varying vec2 vUv;
            uniform float uStrength;
            uniform float uAspect;
            
            void main() {
                vUv = uv;

                if (uAspect > 1.0) {
                    vUv.y = vUv.y / uAspect + (1.0 - 1.0 / uAspect) * 0.5;
                } else {
                    vUv.x = vUv.x * uAspect + (1.0 - uAspect) * 0.5;
                }

                vec3 newPosition = position;
                
                newPosition.z += pow(newPosition.x, 2.0) * uStrength;
                
                gl_Position = projectionMatrix * modelViewMatrix * vec4(newPosition, 1.0);
            }
        `;

        const fragmentShader = `
            uniform float uAlpha;
            varying vec2 vUv;
            uniform vec3 uColor;
            uniform sampler2D uTexture;
            
            void main() {
                vec4 texColor = texture2D(uTexture, vUv);
                if (gl_FrontFacing) {
                    gl_FragColor = texture2D(uTexture, vUv);
                } else {
                    gl_FragColor = texture2D(uTexture, vec2(1.0 - vUv.x, vUv.y));
                }
                gl_FragColor.a = uAlpha;
            }
        `;

        const planes = [];
        const count = 8;

        for (let i = 0; i < count; i++) {
            const geometry = new THREE.PlaneGeometry(planeWidth, planeHeight, 32, 1);
            const video = Assets.menuVideos[i]
            const material = new THREE.ShaderMaterial({
                vertexShader,
                fragmentShader,
                uniforms: {
                    uStrength: { value: -0.125 },
                    uAlpha: { value: 1 },
                    uColor: { value: new THREE.Color(0xffffff).convertSRGBToLinear() },
                    uTexture: { value: video },
                    uAspect: { value: (window.innerWidth / window.innerHeight) / (video?.width / video?.height)   }
                },
                transparent: true,
                side: THREE.DoubleSide
            });
            const plane = new THREE.Mesh(geometry, material);
            plane.categories = video?.categories
            
            this.rotor.add(plane);
            planes.push(plane);
        }

        planes.forEach((plane, i) => {
            const angle = (i / count) * Math.PI * 2;
            
            gsap.set(plane.position, {
                x: Math.cos(angle) * radius,
                z: Math.sin(angle) * radius,
                y: 0,
                ease: "expo.out",
            });
            
            gsap.set(plane.rotation, {
                y: -angle + Math.PI / 2, 
                ease: "expo.out",
            });
        });

        this.planes = planes
        


        const geometry = new THREE.PlaneGeometry(planeWidth, planeHeight, 1, 1);
        const material = new THREE.ShaderMaterial({
            vertexShader: `
            varying vec2 vUv;
            uniform float uAspect;

            void main() {
                vUv = uv;

                if (uAspect > 1.0) {
                    vUv.y = vUv.y / uAspect + (1.0 - 1.0 / uAspect) * 0.5;
                } else {
                    vUv.x = vUv.x * uAspect + (1.0 - uAspect) * 0.5;
                }

                gl_Position = vec4(position.xy, 0.0, 1.0);
            }
        `,
  fragmentShader: `
                varying vec2 vUv;

                uniform sampler2D uTexture;
                uniform sampler2D disp;
                uniform sampler2D perlin;

                uniform float dispFactor;
                uniform float effectFactor;
                uniform float organic;
                uniform float uTime; // Add this for animated noise

                // Helper for pseudo-random noise
                float random(vec2 p) {
                    return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453);
                }

                void main() {
                    vec2 uv = vUv;

                    vec4 dispTex = texture2D(disp, uv);
                    vec4 disp2 = texture2D(perlin, uv);

                    vec2 distortedPosition = vec2(
                        uv.x + dispFactor * (sin(dispTex.r * effectFactor * 20.0)), 
                        uv.y - dispFactor * (cos(dispTex.r * effectFactor * 10.0))
                    );
                    distortedPosition.y -= (disp2.t * organic) * dispFactor;

                    float shift = 0.035 * dispFactor; 
                    
                    float r = texture2D(uTexture, distortedPosition + vec2(shift, 0.0)).r;
                    float g = texture2D(uTexture, distortedPosition).g;
                    float b = texture2D(uTexture, distortedPosition - vec2(shift, 0.0)).b;
                    
                    vec4 color = vec4(r, g, b, 1.0);

                    float noise = (random(uv + uTime) - 0.5) * 0.3; 
                    color.rgb += noise;

                    gl_FragColor = color;
                }
            `,
            uniforms: {
                uColor: { value: new THREE.Color(0xffffff).convertSRGBToLinear() },
                uTexture: { value: Assets.menuTransition[0] },
                uAspect: { value: (planeWidth / planeHeight) / (1920 / 1080)   },
                uTime: { value: 0  },

                dispFactor: {
                    value: 0.05
                },
                organic: {
                    value: 0.01
                },
                effectFactor: {
                    value: 0.025
                },
                disp: {
                    value: Assets.perlin
                },
                perlin: {
                    value: Assets.perlin
                },
            },
            transparent: true,
            side: THREE.DoubleSide
        });
        const plane = new THREE.Mesh(geometry, material);
        plane.position.z = -4.5
        this.transitionPlane = plane

        this.scene.add(plane)
    }

    enter() {
        this.leaveTimeline?.kill()
        
        const { planeWidth, planeHeight, camera, radius } = this
        this.planes.forEach((plane, i) => {
            plane.material.uniforms.uAspect.value = (planeWidth / planeHeight) / (Assets.menuVideos[i]?.width / Assets.menuVideos[i]?.height)
        });

        const fovInRadians = (camera.fov * Math.PI) / 180;
        
        const distToFillHeight = planeHeight / (2 * Math.tan(fovInRadians / 2));
        const distToFillWidth = (planeWidth / camera.aspect) / (2 * Math.tan(fovInRadians / 2));

        const targetDistance = Math.min(distToFillHeight, distToFillWidth);
        
        const duration = 1;
        const timeline = gsap.timeline({
            onComplete: () => {
                this.state = "entered"
            }
        });


        if (this.state === 'left') {
            this.transitionPlane.material.uniforms.uAspect.value =  (window.innerWidth / window.innerHeight) / (1920 / 1080)
                
            const lerp = {
                step: 0
            }
            timeline.to(lerp, {      
                step: 28,
                ease: "steps(28)", 
                duration: 0.8,
                onStart: () => {
                    this.transitionPlane.visible = true
                },
                onUpdate: () => {
                    this.transitionPlane.material.uniforms.uTexture.value = Assets.menuTransition[lerp.step]
                    this.transitionPlane.material.uniforms.uTime.value +=0.01
                },
                onComplete: () => {
                    this.transitionPlane.visible = false
                
                }
            }, 'pre-enter')
            timeline.to({}, {}, 'pre-enter')

        } else {
            this.transitionPlane.visible = false
        }
        this.state = "entering"

        gsap.set(this.rotor.position, {
            z: radius - targetDistance
        })
        this.rotor.position.y = -0
        this.rotor.rotation.x = -0
        this.container.rotation.z = 0
        timeline
            // .delay(1)
            .to(this.rotor.position, {
                y: -1.2,
                z: -6.14,
                duration
            }, 'a')
            .to(this.rotor.rotation, {
                x: -0.65,
                duration
            }, 'a')
            .to(this, { entered: 1, duration, ease: "power2.in" },"a")
            .to(this.container.rotation, {
                z: -0.25,
                duration
            }, 'a')

        this.enterTimeline = timeline
    }
    getCurrentIndex() {
        const count = 8;
        const rotation = this.rotor.rotation.y;
        
        const normalizedRotation = this.wrap360(rotation - 0.5 * Math.PI) / (Math.PI * 2)
        
        const index = Math.round(normalizedRotation * 8)

        return index;
    }
    leave(nextIndex) {
        this.enterTimeline?.kill()
        this.state = "leaving"
        const count = 8
        const { planeWidth, planeHeight, camera, radius } = this
        const fovInRadians = (camera.fov * Math.PI) / 180;
        
        const distToFillHeight = planeHeight / (2 * Math.tan(fovInRadians / 2));
        const distToFillWidth = (planeWidth / camera.aspect) / (2 * Math.tan(fovInRadians / 2));

        const targetDistance = Math.min(distToFillHeight, distToFillWidth);
        
        const duration = 1;
        const timeline = gsap.timeline({
            onComplete: () => {
                gsap.to(this, { entered: 0, ease: "power2.out" }),
                this.state = "left"
            }
        });

        let targetY = snapToPiEighths(this.rotor.rotation.y + Math.PI * 2 * 7/8);
        
        if (nextIndex > -1) {
            const currentIndex = this.getCurrentIndex();
            let steps = nextIndex - currentIndex;
            if (steps < 4) {
                steps += 8
            }
            if (steps < -4) {
                steps += 8
            }
            targetY = snapToPiEighths(this.rotor.rotation.y + Math.PI * 2 * steps/8)
        }

        timeline
            .to(this.container.rotation, {
                z: 0,
                duration
            }, 'a')

            .to(this.rotor.position, {
                y: 0,
                z: radius - targetDistance,
                duration
            }, 'a')
            .to(this.rotor.rotation, {
                y: targetY,
                z: 0.25,
                duration
            }, 'a')
            .to(this.rotor.rotation, {
                z: 0,
                duration: duration * 0.5
            }, `a+=${duration * 0.5}`)

            .to(this.rotor.rotation, {
                x: 0,
                duration
            }, 'a')

            const lerp = {
                step: 0
            }
            timeline.to(lerp, {      
                step: 28,
                ease: "steps(28)", 
                duration: 0.8,
                onStart: () => {
                    this.transitionPlane.visible = true
                },
                onUpdate: () => {
                    this.transitionPlane.material.uniforms.uTexture.value = Assets.menuTransition[lerp.step]
                    this.transitionPlane.material.uniforms.uTime.value +=0.01
                },
                onComplete: () => {
                    this.transitionPlane.visible = false
                
                }
            }, 'pre-enterleave')
        this.leaveTimeline = timeline
        return timeline;
    }

    handleRender() {
        if (this.entered > 0) {
            this.targetVelocity *= this.friction;
            const totalVelocity = (this.baseSpeed + this.targetVelocity) * this.entered;
            this.rotor.rotation.y = this.wrap360(this.rotor.rotation.y +  totalVelocity);
        }
    }

    handleResize(width, height) {
        this.transitionPlane.material.uniforms.uAspect.value = (width / height) / (1920 / 1080)
    }

    dispose() {
    }
}